// Lib
import React, { createContext } from 'react';
import { Provider, createDispatchHook } from 'react-redux';

export const MeasurementsStoreContext = createContext();

export const MeasurementsProvider = (props) => <Provider context={MeasurementsStoreContext} {...props} />;

export const useMeasurementsDispatch = createDispatchHook(MeasurementsStoreContext);
